import PoiAttributeCreate from "src/resources/poi-attributes/PoiAttributeCreate"
import PoiAttributeEdit from "src/resources/poi-attributes/PoiAttributeEdit"

const resource = {
  create: PoiAttributeCreate,
  edit: PoiAttributeEdit,
}

export default resource
